import { Button, Typography, Icon } from "@plum-xoxo/admin-dsm";
import React from "react";
import styled from "styled-components";
import config from "config";

const MainDiv = styled.div`
  width: 761px;
  margin: auto;
  margin-top: 48px;
`;
const OuterDiv = styled.div`
  border-radius: 8px;
  height: 168px;
  border: 1px solid ${(props) => props.theme.palette.light.c300};
  .content {
    width: 420px;
  }
  .buttons {
    padding: 20px;
    button {
      width: 166px;
      height: 50px;
    }
  }
`;
const StyledDiv1 = styled.div`
  border-radius: 8px 0 0 8px;
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
  width: 161px;
  background-color: ${(props) =>
    props.first
      ? props.theme.palette.yellow.c000
      : props.theme.palette.primary.c00};
  border-right: 1px solid ${(props) => props.theme.palette.light.c300};
`;
const DomainExists = () => {
  const url = config.storeFrontUrl.replace(/\/$/g, "");

  return (
    <MainDiv className="d-flex gap-16 flex-column">
      <div>
        <Typography.BodySmall className="m-0">
          Welcome back,
        </Typography.BodySmall>
        <Typography.H1>What would you like to do today?</Typography.H1>
      </div>
      <OuterDiv className="d-flex align-items-center justify-content-center">
        <StyledDiv1 first>
          <Icon iconName="PlumGiftCard" color="yellow" shade="c300" size={32} />
        </StyledDiv1>
        <div className="p-24 content">
          <Typography.H2>I want to redeem rewards</Typography.H2>
          <Typography.BodySmall>
            Redeem points, codes, or links for gift cards, merchandise,
            experiences, and more.
          </Typography.BodySmall>
        </div>
        <div className="d-flex flex-column gap-20 buttons">
          <Button
            variant="outlined"
            onClick={() => {
              window.location.href = url + `/marketplace/login`;
            }}
          >
            Redeem Points
          </Button>
          <Button
            variant="outlined"
            onClick={() => {
              window.location.href = url + `/marketplace/vouchers`;
            }}
          >
            Redeem Codes
          </Button>
        </div>
      </OuterDiv>
      <OuterDiv className="d-flex align-items-center justify-content-center">
        <StyledDiv1>
          <Icon iconName="PlumGiftCard" color="primary" shade="c02" size={32} />
        </StyledDiv1>
        <div className="p-24 content">
          <Typography.H2>I want to send rewards</Typography.H2>
          <Typography.BodySmall>
            Access your admin account to send and manage rewards to your
            recipients.
          </Typography.BodySmall>
        </div>
        <div className="buttons">
          <Button
            variant="outlined"
            onClick={() => {
              window.location.href = url + `/marketplace/login`;
            }}
          >
            Login as Admin
          </Button>
        </div>
      </OuterDiv>
    </MainDiv>
  );
};

export default DomainExists;
